export const AuthReducer = (state, action) => {
	switch(action.type) {
		case 'SWITCH_AUTH' :
			return { isAuth : action.auth, uid: action.uid };
		default :
			return state;
	}
}